var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJersey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.098 411.875L303.223 256.001H303.222L459.098 100.124C452.375 91.3881 445.021 82.9831 437.02 74.9801C429.017 66.9781 420.613 59.6231 411.876 52.9021L256.001 208.777L256 208.778L100.125 52.9021C91.3903 59.6241 82.9843 66.9771 74.9813 74.9801C66.9783 82.9831 59.6243 91.3881 52.9033 100.124L208.778 255.998L208.779 255.999L52.9023 411.876C59.6253 420.612 66.9793 429.017 74.9803 437.02C82.9833 445.022 91.3873 452.377 100.124 459.098L256 303.223L256.001 303.222L411.876 459.097C420.611 452.375 429.017 445.021 437.02 437.019C445.023 429.016 452.376 420.611 459.098 411.875V411.875Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.478 77.913L256 89.043L300.522 77.913V40.07L282.713 48.974L256 22.261L229.287 48.974L211.478 40.07V77.913Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.478 77.9131V105.741C211.478 139.821 256 150.263 256 150.263C256 150.263 300.522 139.82 300.522 105.741V77.9131H211.478Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJersey);
export default __webpack_public_path__ + "static/media/jersey.7d5c9593a910176921783a2f151ce8d4.svg";
export { ForwardRef as ReactComponent };